// src/pages/AboutUs.js
import React from 'react';

const AboutUs = () => {
  const backgroundImage =
    'https://static.vecteezy.com/system/resources/thumbnails/024/494/104/small_2x/abstract-light-background-blue-background-with-waves-free-photo.jpg';

  const leftImage =
    'https://www.shutterstock.com/shutterstock/photos/1842408310/display_1500/stock-vector-lost-and-found-service-concept-with-cartoon-characters-loosing-baggage-while-airline-flight-1842408310.jpg';

  const rightImage =
    'https://img.freepik.com/premium-vector/cartoon-young-man-returning-lost-wallet-lost-found-service_341509-1088.jpg?w=360';

  return (
    <div
      style={{
        minHeight: '70vh',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        padding: '2rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          zIndex: 1,
        }}
      />

      {/* Content Layout with Images */}
      <div
        style={{
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1.5rem',
          flexWrap: 'wrap',
        }}
      >
        {/* Left Image */}
        <img
          src={leftImage}
          alt="Lost and Found Cartoon Left"
          style={{
            maxWidth: '180px',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
          }}
        />

        {/* Main Content */}
        <div
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: '2rem',
            borderRadius: '12px',
            maxWidth: '600px',
            width: '100%',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            textAlign: 'left',
          }}
        >
          <h2 style={{ color: '#1B3B6F', marginBottom: '1rem' }}>About Us</h2>

          <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '1rem' }}>
            The USIU-Africa Asset Recovery System is a digital platform designed to help students and staff efficiently report, find, and recover lost items on campus.
          </p>

          <p style={{ fontSize: '1.1rem', color: '#333', marginBottom: '1rem' }}>
            Our mission is to create a trusted environment where all lost and found items can be tracked and managed transparently. With a centralized system, we ensure minimal loss of personal belongings and promote honesty within our community.
          </p>

          <p style={{ fontSize: '1.1rem', color: '#333' }}>
            This system is maintained by the USIU Tech Team and continuously improved with input from students, security staff, and administration.
          </p>
        </div>

        {/* Right Image */}
        <img
          src={rightImage}
          alt="Lost and Found Cartoon Right"
          style={{
            maxWidth: '180px',
            height: 'auto',
            borderRadius: '12px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
          }}
        />
      </div>
    </div>
  );
};

export default AboutUs;
